import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme, Grid } from '../../../../base';
import { IChartTooltipProps } from '../../../../common';

const ComparisonChartTooltip = ({
    active,
    payload,
    label,
}: IChartTooltipProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    if (!active || !payload?.length) return null;

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.grey[800],
                color: theme.palette.common.white,
                padding: theme.spacing(1, 1.5),
                borderRadius: 1.5,
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    fontWeight: 700,
                    display: 'block',
                    marginBottom: theme.spacing(0.5),
                }}
            >
                {label}
            </Typography>
            {payload.map((entry) => (
                <Grid key={entry.name} container alignItems="center" gap={0.5}>
                    <Box
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            backgroundColor:
                                entry.color ?? theme.palette.grey[400],
                        }}
                    />
                    <Typography variant="caption">{`${entry.name}:`}</Typography>
                    <Typography variant="caption">
                        {`${Math.round(entry.value)} ${t('reportsPage.timeToHireReport.days')}`}
                    </Typography>
                </Grid>
            ))}
        </Box>
    );
};

export default ComparisonChartTooltip;
